import React, { Component, Fragment } from "react";
import {
  AppBar,
  Button,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { LOGO_VERIFY } from "../../../config/config";

import HelperClass from "../../../config/helperClass";
import { tableLoader } from "../../ContentLoaders/table_loader";
import Skeleton from "@material-ui/lab/Skeleton";
import { Helmet, HelmetProvider } from "react-helmet-async";
const auth = new HelperClass();
export class DomainConnect extends Component {
  continue = () => {
    //e.preventDefault();
    this.props.nextStep();
  };
  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  submitForms = (e) => {
    e.preventDefault();
    this.setState({
      tableLoader: true,
      disabled: true,
    });
    this.props.formSubmit();
    setTimeout(() => {
      this.setState({
        tableLoader: false,
        disabled: false,
      });
      this.continue();
    }, 3000);
  };

  constructor() {
    super();
    this.state = {
      disabled: false,
      errorMessage: "",
      tableLoader: false,
      dnsList: [],
    };
  }

  modalHideIns = () => {
    window.$("#instructionsModal").modal("hide");
  };

  render() {
    const { values, handleChange } = this.props;

    return (
      <>
        <HelmetProvider>
          <Helmet>
            <link
              rel="stylesheet"
              href="../../assets/ui_latest/css/dashlite.css?ver=3.0.3"
            />
            <link
              id="skin-default"
              rel="stylesheet"
              href="../../assets/ui_latest/csstheme.css?ver=3.0.3"
            />
          </Helmet>
        </HelmetProvider>
        <div className="nk-block nk-block-lg" style={{ width: "100%" }}>
          <div
            className="card card-bordered"
            style={{
              border: "none",
              paddingTop: "5%",
              paddingLeft: "5%",
              paddingRight: "5%",
            }}
          >
            <form
              className="nk-stepper stepper-init is-alter nk-stepper-s1"
              action="#"
              id="stepper-create-profile"
            >
              <div className="row g-0 col-sep col-sep-md col-sep-xl">
                <div className="col-md-4 col-xl-4">
                  <div className="card-inner">
                    <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                      {/*<li className="done">
                        <div className="step-item">
                          <div className="step-text">
                            <div className="lead-text">Company Info</div>
                            <div className="sub-text">
                              Company name and 499 Filer ID
                            </div>
                          </div>
                        </div>
          </li>*/}
                      <li className="done">
                        <div className="step-item">
                          <div className="step-text">
                            <div className="lead-text">Contact Info</div>
                            <div className="sub-text">
                              Other contact information
                            </div>
                          </div>
                        </div>
                      </li>
                      {/*<li className="done">
                        <div className="step-item">
                          <div className="step-text">
                            <div className="lead-text">Other Info</div>
                            <div className="sub-text">
                              Number of employes in the company
                            </div>
                          </div>
                        </div>
                      </li>*/}
                      <li className="done">
                        <div className="step-item">
                          <div className="step-text">
                            <div className="lead-text">Account Password</div>
                            <div className="sub-text">
                              Account password to access the portal
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="current">
                        <div className="step-item">
                          <div className="step-text">
                            <div className="lead-text">Preview Details</div>
                            <div className="sub-text">Review and Submit</div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="step-item">
                          <div className="step-text">
                            <div className="lead-text">Completed</div>
                            <div className="sub-text">You are done.</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-8 col-xl-8">
                  <div className="card-inner">
                    <div className="nk-stepper-content">
                      <div className="nk-stepper-steps stepper-steps">
                        <div className="nk-stepper-step done"></div>
                        <div className="nk-stepper-step done"></div>
                        <div className="nk-stepper-step done"></div>
                        <div className="nk-stepper-step done"></div>
                        <div className="nk-stepper-step text-center active">
                          <h5 className="title mb-2">Preview Details!</h5>
                          <p className="text-soft">
                            Review and submit your details
                          </p>
                          <div className="card card-bordered card-full">
                            <div className="card-inner-group">
                              <div className="card-inner">
                                <div className="card-title-group">
                                  <div className="card-title">
                                    <h6 className="title">SignUp Details</h6>
                                  </div>
                                  <div className="card-tools"></div>
                                </div>
                              </div>
                              <div className="card-inner card-inner-md">
                                <div className="user-card">
                                  <div className="user-avatar bg-primary-dim">
                                    <span>
                                      <em className="icon ni ni-home"></em>
                                    </span>
                                  </div>
                                  <div className="user-info">
                                    <span className="lead-text">
                                      Company Name
                                    </span>
                                    <span className="sub-text">
                                      {values.company_name}
                                    </span>
                                  </div>
                                  <div className="user-action"></div>
                                </div>
                              </div>
                              {/*<div className="card-inner card-inner-md">
                                <div className="user-card">
                                  <div className="user-avatar bg-pink-dim">
                                    <span>
                                      <em className="icon ni ni-home"></em>
                                    </span>
                                  </div>
                                  <div className="user-info">
                                    <span className="lead-text">
                                      499 Filer ID
                                    </span>
                                    <span className="sub-text">
                                      {values.filer_id}
                                    </span>
                                  </div>
                                  <div className="user-action"></div>
                                </div>
                    </div>*/}
                              <div className="card-inner card-inner-md">
                                <div className="user-card">
                                  <div className="user-avatar bg-warning-dim">
                                    <span>
                                      <em className="icon ni ni-user-list"></em>
                                    </span>
                                  </div>
                                  <div className="user-info">
                                    <span className="lead-text">Full Name</span>
                                    <span className="sub-text">
                                      {values.name}
                                    </span>
                                  </div>
                                  <div className="user-action"></div>
                                </div>
                              </div>
                              {/*<div className="card-inner card-inner-md">
                                <div className="user-card">
                                  <div className="user-avatar bg-success-dim">
                                    <span>
                                      <em className="icon ni ni-user-list"></em>
                                    </span>
                                  </div>
                                  <div className="user-info">
                                    <span className="lead-text">Title</span>
                                    <span className="sub-text">
                                      {values.title}
                                    </span>
                                  </div>
                                  <div className="user-action"></div>
                                </div>
                  </div>*/}
                              <div className="card-inner card-inner-md">
                                <div className="user-card">
                                  <div className="user-avatar bg-danger-dim">
                                    <span>
                                      <em className="icon ni ni-user-list"></em>
                                    </span>
                                  </div>
                                  <div className="user-info">
                                    <span className="lead-text">Email</span>
                                    <span className="sub-text">
                                      {values.email}
                                    </span>
                                  </div>
                                  <div className="user-action"></div>
                                </div>
                              </div>
                              <div className="card-inner card-inner-md">
                                <div className="user-card">
                                  <div className="user-avatar bg-success-dim">
                                    <span>
                                      <em className="icon ni ni-user-list"></em>
                                    </span>
                                  </div>
                                  <div className="user-info">
                                    <span className="lead-text">Phone</span>
                                    <span className="sub-text">
                                      {values.phone}
                                    </span>
                                  </div>
                                  <div className="user-action"></div>
                                </div>
                              </div>
                              {/*<div className="card-inner card-inner-md">
                                <div className="user-card">
                                  <div className="user-avatar bg-primary-dim">
                                    <span>
                                      <em className="icon ni ni-user-list"></em>
                                    </span>
                                  </div>
                                  <div className="user-info">
                                    <span className="lead-text">
                                      No of Emplyees
                                    </span>
                                    <span className="sub-text">
                                      {values.no_of_employes}
                                    </span>
                                  </div>
                                  <div className="user-action"></div>
                                </div>
                              </div>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                      <ul className="nk-stepper-pagination pt-4 gx-4 gy-2 stepper-pagination">
                        <li className="step-prev">
                          <button
                            type="button"
                            className="btn btn-dim btn-primary"
                            onClick={this.back}
                          >
                            Back
                          </button>
                        </li>
                        <li className="step-next">
                          <button
                            type="button"
                            disabled={this.state.disabled}
                            className="btn btn-primary"
                            onClick={this.submitForms}
                          >
                            Submit
                          </button>
                        </li>
                      </ul>
                      <div
                        className="text-center"
                        style={{ marginTop: "25px" }}
                      >
                        Already have an account ?{" "}
                        <a
                          href={`${auth.getResellerIdentifier()}/client/login`}
                        >
                          Sign in instead
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default DomainConnect;
